import { createContext, useContext, useCallback } from "react";

const BookingCtx = createContext(null);

export const useBooking = () => useContext(BookingCtx);

// Virtual URL used for Google Tag Manager / Google Ads conversion tracking.
const BOOK_ONLINE_VIRTUAL_URL = "http://www.westspringsoptometry.com/book-online";

export function BookingProvider({ children }) {
  // Open the real booking/reorder system in a smaller centered window so the
  // site stays visible behind it. (Embedding via iframe breaks Opto's
  // multi-step flow because its session cookie is SameSite=Lax and browsers
  // drop it inside a cross-site iframe.)
  const open = useCallback((url) => {
    // Fire a GTM dataLayer event when the Book Online button is pressed so the
    // booking conversion tag fires. Includes a virtual page path so it also
    // works for URL/page-path based triggers.
    if (url && url.includes("booking.opto.com")) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "book_online_click",
        page_path: "/book-online",
        page_location: BOOK_ONLINE_VIRTUAL_URL,
        booking_url: url,
      });
    }

    const w = Math.min(1024, Math.floor(window.innerWidth * 0.7));
    const h = Math.min(860, Math.floor(window.innerHeight * 0.85));
    const dualLeft = window.screenLeft ?? window.screenX ?? 0;
    const dualTop = window.screenTop ?? window.screenY ?? 0;
    const outerW = window.outerWidth || window.innerWidth;
    const outerH = window.outerHeight || window.innerHeight;
    const left = dualLeft + Math.max(0, (outerW - w) / 2);
    const top = dualTop + Math.max(0, (outerH - h) / 2);
    const features = `popup=yes,width=${w},height=${h},left=${left},top=${top},noopener,noreferrer,scrollbars=yes,resizable=yes`;
    const popup = window.open(url, "wso-booking", features);
    // If the browser blocks the popup, fall back to a new tab.
    if (!popup) window.open(url, "_blank", "noopener,noreferrer");
  }, []);

  return (
    <BookingCtx.Provider value={{ open, close: () => {} }}>
      {children}
    </BookingCtx.Provider>
  );
}
